/**
 * 动态加载脚本 by meijiangshun
 * @param {脚本url} src
 */
function loadScript(src) {
    return new Promise((resolve, reject) => {
        // 如果已经加载了脚本js，直接调用
        if (_checkIsLoadScript(src)) {
            resolve()
        }
        let scriptNode = document.createElement('script')
        scriptNode.type = 'text/javascript'
        scriptNode.src = src
        document.body.appendChild(scriptNode)
        if (scriptNode.readyState) {
            // 兼容IE的script加载事件
            scriptNode.onreadystatechange = () => {
                if (scriptNode.readyState === 'complete' || scriptNode.readyState === 'loaded') {
                    // 防止加载两次
                    scriptNode.onreadystatechange = null
                    resolve()
                }
            }
        } else {
            scriptNode.onload = () => {
                resolve()
            }
        }
    })
}

/**
 * 检测是否加载了 js 文件
 */
function _checkIsLoadScript(src) {
    let scriptObjs = document.getElementsByTagName('script')
    for (let sObj of scriptObjs) {
        if (sObj.src === src) {
            return true
        }
    }
    return false
}

export default loadScript



// WEBPACK FOOTER //
// ./src/utils/loadScript.js